import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'classFilter' })

export class ClassFilterPipe implements PipeTransform {
  transform(items: any[], searchText: string, searchableProperties: string[]): any[] {
    if (!items) return [];
    if (!searchText) return items;
    if (!searchableProperties || !searchableProperties.length || (searchableProperties.length == 0)) {
      return items;
    }
    searchText = searchText.trim().toLowerCase();
    return items.filter(it => {
      for (var i = 0; i < searchableProperties.length; i++) {
        if (it[searchableProperties[i]]) {
          switch (typeof it[searchableProperties[i]]) {
            case 'boolean': {
              if (it[searchableProperties[i]] == true) {
                return it;
              }
              break;
            }
            default: {
              if (it[searchableProperties[i]].toLowerCase().includes(searchText)) {
                return it;
              }
            }
          }
        }

      }
    });
  }
}
